import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { setOptions, importLibrary } from '@googlemaps/js-api-loader';
import { environment } from '../../../../../../../environments/environment';
import { forkJoin, from, map, Observable, of } from 'rxjs';

const mapsLoader$: Observable<void> | null = null;

@Injectable({ providedIn: 'root' })
export class GoMapService {
    constructor(@Inject(PLATFORM_ID) private platformId: object) {}

    load(): Observable<void> {
        if (!isPlatformBrowser(this.platformId) || window.google?.maps) {
            return of(undefined as void);
        }

        if (mapsLoader$) {
            return mapsLoader$;
        }

        setOptions({
            key: environment.googleMapsApiKey,
            v: 'quarterly',
            libraries: ['places', 'marker'],
            mapIds: [environment.googleMapsMapId],
        });

        return forkJoin([
            from(importLibrary('maps')),
            from(importLibrary('places')),
            from(importLibrary('marker')),
        ]).pipe(map(() => void 0));
    }
}
